import "~/styles/vendor/bootstrap-clockpicker.min.css";
import "~/misc/vendor/bootstrap-clockpicker.min.js";

export function initClockpicker() {
  //console.log('initClockpicker');
  $(".clockpicker").clockpicker();
}
